import React, { useState, useLayoutEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { authorisationConverter, logout, useFetchAuthorisation } from '../utils/AppFunctions'
import { FaAngleRight, FaCross, FaPrayingHands } from 'react-icons/fa'
import { MdAccountBalance, MdBook, MdExitToApp, MdFastfood, MdLibraryBooks, MdMonetizationOn, MdMoney, MdMusicNote, MdOutlineAnnouncement, MdOutlineArticle, MdOutlineChurch, MdOutlineEvent, MdOutlineGroup, MdOutlineGroupWork, MdOutlineGroups2, MdOutlineLabel, MdOutlineMonetizationOn, MdOutlineMusicNote, MdOutlineNotifications, MdOutlineSettings, MdOutlineTravelExplore } from 'react-icons/md'
import config from '../app-config'
import { isMobile, user_has_permissions } from '../utils/helper'
import { useUserConfig } from '../contexts/UserConfigContext'

export default function AdminNavbar({ selected }) {
    // let { configData } = useFetchAuthorisation("user")
    const configData = useUserConfig()?.configData || []

    const size = 20
    const color = "white"
    const navigate = useNavigate()

    const [showMobileNavbar, setShowMobileNavbar] = useState(false)

    const [header, setHeader] = useState(document.getElementById("user-header")?.clientHeight)
    const [navbarWidth, setNavbarWidth] = useState(document.getElementById("navbar")?.clientWidth)
    const [selectedMainCategory, setSelectedMainCategory] = useState("")

    useLayoutEffect(() => {
        setHeader(document.getElementById("user-header")?.clientHeight)
        setNavbarWidth(document.getElementById("navbar")?.clientWidth)
    }, [header, navbarWidth])


    let items = [
        {
            name: config.client_name,
            permissions: ["analytics:view"],
            children: [
                {
                    name: "Dashboard",
                    icon: <FaCross size={size} color={color} />,
                    link: "/admin",
                    permissions: ["analytics:view"],
                },
                {
                    name: "Ministry",
                    icon: <MdMusicNote size={size} color={color} />,
                    link: "/admin/ministry",
                    permissions: [],
                },
                {
                    name: "Cafe",
                    icon: <MdFastfood size={size} color={color} />,
                    link: "/admin/cafe",
                    permissions: ["cafe:list"],
                },
                {
                    name: "Settings",
                    icon: <MdOutlineSettings size={size} color={color} />,
                    link: "/admin/settings?state=general",
                    permissions: ["config:update_general"],
                },
            ],
        },
        {
            name: "Website",
            permissions: [],
            children: [
                {
                    name: "Church Staff",
                    icon: <MdOutlineGroup size={size} color={color} />,
                    link: "/admin/staff",
                    permissions: ["website:staff:manage"],
                },
                {
                    name: "Contact Form",
                    icon: <MdOutlineArticle size={size} color={color} />,
                    link: "/admin/contact",
                    permissions: ["contact:list"],
                },
                {
                    name: "Policies",
                    icon: <MdOutlineArticle size={size} color={color} />,
                    link: "/admin/website/policies",
                    permissions: ["website:policies:publish"],
                },
            ],
        },
        {
            name: "Service Management",
            permissions: ["services:list_all"],
            children: [
                {
                    name: "Services",
                    icon: <MdOutlineChurch size={size} color={color} />,
                    link: "/admin/services",
                    permissions: ["services:list_all"],
                },
                {
                    name: "Special Services",
                    icon: <MdOutlineChurch size={size} color={color} />,
                    link: "/admin/special/services",
                    permissions: ["special_services:list"],
                },
                {
                    name: "Corporate Prayer",
                    icon: <FaPrayingHands size={size} color={color} />,
                    link: "/admin/prayer",
                    permissions: ["prayer:list:list"],
                },
                {
                    name: "Prayer Support",
                    icon: <FaPrayingHands size={size} color={color} />,
                    link: "/admin/prayer/support",
                    permissions: ["prayer:published:list"],
                },
            ],
        },
        {
            name: "Resources",
            permissions: ["resources:list"],
            children: [
                {
                    name: "Plans & Materials",
                    icon: <MdBook size={size} color={color} />,
                    link: "/admin/plan",
                    permissions: ["plan:list"],
                },
                {
                    name: "Resources",
                    icon: <MdBook size={size} color={color} />,
                    link: "/admin/resources",
                    permissions: ["resources:list"],
                },
                {
                    name: "Bulletin",
                    icon: <MdOutlineArticle size={size} color={color} />,
                    link: "/admin/bulletin",
                    permissions: ["bulletin:list"],
                },
            ],
        },
        {
            name: "Library",
            permissions: ["library:list"],
            children: [
                {
                    name: "Library Items",
                    icon: <MdLibraryBooks size={size} color={color} />,
                    link: "/admin/library",
                    permissions: ["library:list"],
                },
                {
                    name: "Borrowed Items",
                    icon: <MdLibraryBooks size={size} color={color} />,
                    link: "/admin/library/loan",
                    permissions: ["library:list"],
                },
            ],
        },
        {
            name: "Accounts & Claims",
            permissions: ["claims:list"],
            children: [
                {
                    name: "Accounts",
                    icon: <MdAccountBalance size={size} color={color} />,
                    link: "/admin/accounts",
                    permissions: ["accounts:list"],
                },
                {
                    name: "Claims",
                    icon: <MdOutlineMonetizationOn size={size} color={color} />,
                    link: "/admin/claims",
                    permissions: ["claims:list"],
                },
            ],
        },
        {
            name: "Facilities & Maintenance",
            permissions: ["locations:read"],
            children: [
                {
                    name: "Locations & Facilities",
                    icon: <MdOutlineChurch size={size} color={color} />,
                    link: "/admin/locations",
                    permissions: ["locations:read"],
                },
                {
                    name: "Facility Bookings",
                    icon: <MdOutlineEvent size={size} color={color} />,
                    link: "/admin/locations/bookings",
                    permissions: ["locations:read"],
                },
                {
                    name: "Maintenance Issues",
                    icon: <MdOutlineArticle size={size} color={color} />,
                    link: "/admin/locations/reports",
                    permissions: ["locations:read"],
                },
            ],
        },
        {
            name: "Events",
            permissions: ["events:list"],
            children: [
                {
                    name: "Events",
                    icon: <MdOutlineEvent size={size} color={color} />,
                    link: "/admin/events",
                    permissions: ["events:list"],
                },
            ],
        },
        {
            name: "ServOps",
            permissions: ["missions:create"],
            children: [
                {
                    name: "Missions",
                    icon: <MdOutlineTravelExplore size={size} color={color} />,
                    link: "/admin/missions",
                    permissions: ["missions:create"],
                },
            ],
        },
        {
            name: "News & Announcements",
            permissions: ["announcements:list"],
            children: [
                {
                    name: "Announcements",
                    icon: <MdOutlineAnnouncement size={size} color={color} />,
                    link: "/admin/announcements",
                    permissions: ["announcements:list"],
                },
            ],
        },
        {
            name: "Campaigns",
            permissions: ["campaigns:mobile:list"],
            children: [
                {
                    name: "Push Notification",
                    icon: <MdOutlineNotifications size={size} color={color} />,
                    link: "/admin/campaigns/push",
                    permissions: ["campaigns:mobile:list"],
                },
                {
                    name: "Email Newsletter",
                    icon: <MdOutlineNotifications size={size} color={color} />,
                    link: "/admin/campaigns/email-newsletter",
                    permissions: ["campaigns:email:list"],
                },
                {
                    name: "Groups & Tags",
                    icon: <MdOutlineLabel size={size} color={color} />,
                    link: "/admin/campaigns/groups-tags",
                    permissions: ["campaigns:groups:list"],
                },
            ],
        },
        {
            name: "Media & Gallery",
            permissions: ["audio:list"],
            children: [
                {
                    name: "Audio & Worship",
                    icon: <MdOutlineMusicNote size={size} color={color} />,
                    link: "/admin/audio",
                    permissions: ["audio:list"],
                },
            ],
        },
        {
            name: "Disciple Groups",
            permissions: ["dg:clusters:list"],
            children: [
                {
                    name: "DG Clusters",
                    icon: <MdOutlineGroupWork size={size} color={color} />,
                    link: "/admin/dg/clusters",
                    permissions: ["dg:clusters:list"],
                },
                {
                    name: "Disciple Groups",
                    icon: <MdOutlineGroups2 size={size} color={color} />,
                    link: "/admin/dg",
                    permissions: ["dg:list"],
                },
            ],
        },
        {
            name: "User Management",
            permissions: ["users:list"],
            children: [
                {
                    name: "Users",
                    icon: <MdOutlineGroup size={size} color={color} />,
                    link: "/admin/users",
                    permissions: ["users:list"],
                },
                {
                    name: "Roles & Permissions",
                    icon: <MdOutlineGroupWork size={size} color={color} />,
                    link: "/admin/roles-permissions",
                    permissions: ["roles:list"],
                },
            ],
        },
    ];

    return (
        <>
            {/* Mobile Header */}
            {isMobile() && (
                <div className="lg:hidden fixed top-0 left-0 right-0 bg-gradient-to-r from-blue-600 to-blue-700 shadow-lg z-50">
                    <div className="flex items-center justify-between p-4">
                        <div className="flex items-center space-x-3">
                            <img src="/logoWhite.png" alt="BMC Logo" className="h-8 w-auto" />
                            <h1 className="text-lg font-bold text-white">BMC Admin</h1>
                        </div>
                        <button
                            onClick={() => setShowMobileNavbar(!showMobileNavbar)}
                            className="p-2 rounded-lg hover:bg-blue-500/30 transition-colors duration-200"
                        >
                            <div className={`w-6 h-0.5 bg-white mb-1.5 transition-transform duration-200 ${showMobileNavbar ? 'rotate-45 translate-y-2' : ''}`}></div>
                            <div className={`w-6 h-0.5 bg-white mb-1.5 transition-opacity duration-200 ${showMobileNavbar ? 'opacity-0' : ''}`}></div>
                            <div className={`w-6 h-0.5 bg-white transition-transform duration-200 ${showMobileNavbar ? '-rotate-45 -translate-y-2' : ''}`}></div>
                        </button>
                    </div>
                </div>
            )}

            {/* Main Navbar */}
            <div
                className={`${isMobile() ? 'lg:hidden' : 'hidden lg:flex'
                    } transform ${showMobileNavbar ? 'translate-x-0' : isMobile() ? '-translate-x-full' : 'translate-x-0'
                    } transition-transform duration-300 ease-in-out min-w-64 w-64 bg-gradient-to-b from-blue-600 to-blue-800 shadow-xl z-40 h-screen sticky top-0 flex-col flex-shrink-0`}
                style={{ top: isMobile() ? '72px' : '0', height: isMobile() ? 'calc(100vh - 72px)' : '100vh' }}
            >
                {/* Desktop Header - Sticky Top */}
                {!isMobile() && (
                    <div className="flex-shrink-0 p-5 border-b border-blue-500/30 bg-blue-600/20 backdrop-blur-sm">
                        <div className="flex flex-col items-start space-y-2">
                            <img src="/logoWhite.png" alt="BMC Logo" className="h-16 w-auto object-contain" />
                            <div>
                                <h1 className="text-xl font-bold text-white tracking-tight">BMC Admin</h1>
                                <p className="text-xs text-blue-100 font-medium">Management Portal</p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Navigation Items - Scrollable Middle */}
                <nav className="flex-1 overflow-y-auto py-4 px-4 space-y-1">
                    {items.map((item, index) => {
                        console.log({ item, configData })
                        if (!user_has_permissions(configData, item.permissions)) return null
                        const isExpanded = selectedMainCategory === item.name || item.children?.map(child => child.name).includes(selected)

                        return (
                            <div className="mb-4" key={index}>
                                {/* Main Category Header */}
                                <button
                                    className={`w-full flex items-center justify-between px-3 py-3 rounded-lg text-left transition-all duration-200 group ${isExpanded
                                        ? 'bg-blue-500/30 text-white shadow-lg'
                                        : 'text-blue-100 hover:bg-blue-500/20 hover:text-white'
                                        }`}
                                    onClick={() => setSelectedMainCategory(selectedMainCategory === item.name ? '' : item.name)}
                                >
                                    <span className={`text-xs font-semibold tracking-wider uppercase ${isExpanded ? 'text-white' : 'text-blue-200'
                                        }`}>
                                        {item.name}
                                    </span>
                                    <FaAngleRight
                                        size={12}
                                        className={`transform transition-transform duration-200 ${isExpanded ? 'rotate-90' : 'group-hover:translate-x-1'
                                            }`}
                                    />
                                </button>

                                {/* Child Items */}
                                <div className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                    }`}>
                                    <div className="ml-4 mt-2 space-y-1">
                                        {item.children.map((child, childIndex) => {
                                            if (!user_has_permissions(configData, child.permissions)) return null
                                            const isSelected = selected === child.name

                                            return (
                                                <button
                                                    key={childIndex}
                                                    className={`w-full flex items-center space-x-3 px-3 py-2.5 rounded-lg text-left transition-all duration-200 group ${isSelected
                                                        ? 'bg-white/20 text-white shadow-lg border-l-4 border-white'
                                                        : 'text-blue-100 hover:bg-white/10 hover:text-white hover:translate-x-1'
                                                        }`}
                                                    onClick={() => navigate(child.link)}
                                                >
                                                    <div className={`transition-transform duration-200 ${isSelected ? 'scale-110' : 'group-hover:scale-105'
                                                        }`}>
                                                        {child.icon}
                                                    </div>
                                                    <span className="text-sm font-medium">{child.name}</span>
                                                </button>
                                            )
                                        })}
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </nav>

                {/* Sticky Footer with Logout Button */}
                <div className="flex-shrink-0 p-4 border-t border-blue-500/30 bg-blue-900/30 space-y-3">
                    <button
                        onClick={() => logout()}
                        className="w-full flex items-center justify-center space-x-2 px-4 py-2.5 rounded-lg bg-red-500/20 hover:bg-red-600 text-white font-medium text-sm transition-all duration-200 shadow-sm border border-red-400/30 hover:border-red-500 group cursor-pointer"
                    >
                        <MdExitToApp size={18} className="text-red-200 group-hover:text-white transition-colors" />
                        <span>Logout</span>
                    </button>
                    <p className="text-xs text-blue-200 text-center">
                        Built by{' '}
                        <button
                            className="text-white hover:underline hover:text-blue-100 transition-colors duration-200 font-medium"
                            onClick={() => window.open("https://ourcodelab.com")}
                        >
                            OurCodeLab LLP
                        </button>
                        {' '}© {new Date().getFullYear()}
                    </p>
                </div>
            </div>

            {/* Mobile Overlay */}
            {isMobile() && showMobileNavbar && (
                <div
                    className="lg:hidden fixed inset-0 bg-black/50 z-30"
                    style={{ top: '72px' }}
                    onClick={() => setShowMobileNavbar(false)}
                />
            )}
        </>
    )
}
